import Icon from 'veui/components/Icon'

Icon.register({
  save: {
    paths: [
      {
        d: 'M694.7 234.44l-160-161A32 32 0 00512 64H96a32 32 0 00-32 32v576a32 32 0 0032 32h576a32 32 0 0032-32V257a32 32 0 00-9.3-22.56zM256 128h160v224H256zm256 512H256v-64h256zm128 0h-64v-96a32 32 0 00-32-32H224a32 32 0 00-32 32v96h-64V128h64v256a32 32 0 0032 32h224a32 32 0 0032-32V128h18.69L640 270.2z'
      }
    ],
    width: '768',
    height: '768'
  }
})
